import { useMemo } from 'react';
import { ResponsiveLine } from '@nivo/line';
import type { LineSeries, LineSvgProps } from '@nivo/line';
import type { ResponsiveProps } from '@nivo/core';
import { buildNivoTheme } from '../../utils/nivoTheme';

type NivoLineChartProps<Series extends LineSeries> = Omit<ResponsiveProps<LineSvgProps<Series>>, 'theme' | 'animate' | 'data'> & {
    data: readonly Series[];
    height?: string;
    xTitle?: string;
    yTitle?: string;
};

function NivoLineChart<Series extends LineSeries>({
    height = '100%',
    xTitle,
    yTitle,
    margin,
    axisBottom,
    axisLeft,
    enableGridX = false,
    enableGridY = true,
    ...rest
}: NivoLineChartProps<Series>) {
    const theme = useMemo(() => buildNivoTheme(), []);

    const resolvedAxisBottom =
        axisBottom === null ? null : { legendPosition: 'middle' as const, legendOffset: 36, ...axisBottom, ...(xTitle ? { legend: xTitle } : {}) };
    const resolvedAxisLeft =
        axisLeft === null ? null : { legendPosition: 'middle' as const, legendOffset: -50, ...axisLeft, ...(yTitle ? { legend: yTitle } : {}) };

    return (
        <div className='chart-container' style={{ height }}>
            <ResponsiveLine
                {...rest}
                theme={theme}
                animate={false}
                enableGridX={enableGridX}
                enableGridY={enableGridY}
                margin={margin ?? { top: 20, right: 20, bottom: 50, left: 60 }}
                axisBottom={resolvedAxisBottom}
                axisLeft={resolvedAxisLeft}
            />
        </div>
    );
}

export default NivoLineChart;
